import React from 'react';
import { css, keyframes } from '@emotion/css';

const skeletonLoading = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const styles = {
  container: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 40px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    background: white;
    transition: opacity 0.3s ease-in-out;
    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
  `,
  loader: css`
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: ${skeletonLoading} 2s infinite;
    border-radius: 4px;
  `,
  skeletonTitle: css`
    width: 300px;
    height: 24px;
    margin-bottom: 12px;
  `,
  skeletonTitleSmall: css`
    width: 200px;
    height: 24px;
  `,
  skeletonContent: css`
    display: flex;
    justify-content: center;
    gap: 14px;
    margin-top: 20px;
  `,
  skeletonCard: css`
    height: 100px;
    width: 350px;
    border-radius: 8px;
  `,
};

const ImmoAssistantLoading = () => {
  return (
    <div className={`skeleton-container ${css(styles.container)}`}>
      <div className={css(styles.loader, styles.skeletonTitle)}></div>
      <div className={css(styles.loader, styles.skeletonTitleSmall)}></div>
      <div className={styles.skeletonContent}>
        <div className={css(styles.loader, styles.skeletonCard)}></div>
        <div className={css(styles.loader, styles.skeletonCard)}></div>
      </div>
    </div>
  );
};

export default ImmoAssistantLoading;
